import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Navbar from './Header';
import HomePage from './Homepage';
import BriscolaGame from './briscola/Game';
import Ricette from './ricette/RecipeWebsite';
import ExampleUsage from './Exampleusage';
import NotFound from './NotFound';
import WIP from './WorkInProgress';
import './App.css';

function App() {
  return (
    <Router>
        <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/briscola" element={<BriscolaGame />} />
          <Route path="/ricette" element={<WIP/>}/>
          <Route path="/example" element={<ExampleUsage/>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Layout>
    </Router>
  );
}

export default App;